var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Pause2 = function Pause2(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 8 12' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M5.333.47c0-.26.21-.47.465-.47h1.738C7.792 0 8 .208 8 .47v11.06c0 .26-.21.47-.464.47H5.798a.466.466 0 0 1-.465-.47V.47zM0 .47C0 .21.21 0 .464 0h1.738c.257 0 .465.208.465.47v11.06c0 .26-.21.47-.465.47H.464A.466.466 0 0 1 0 11.53V.47z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Pause2;
//# sourceMappingURL=Pause2.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Pause2.js